import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';

const AdminLayout = () => {
  // 🔑 Default Password
  const ADMIN_PASSWORD = 'tinytimes2024'; 

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');

  // Check session on load
  useEffect(() => {
    if (sessionStorage.getItem('adminAuth') === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('adminAuth', 'true');
    } else {
      alert('Incorrect password!');
    }
  };

  // Login Screen
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-green-light to-accent-blue">
        <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4 text-center">
          <div className="text-6xl mb-4">🔐</div>
          <h2 className="text-3xl font-display font-bold text-primary-green-dark mb-2">
            Admin Login
          </h2>
          <p className="text-neutral-gray-dark mb-6">
            Enter password to access admin panel
          </p>

          <form onSubmit={handleLogin} className="space-y-4">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              className="w-full px-4 py-3 rounded-lg border-2 border-primary-green/30 focus:border-primary-green focus:outline-none"
              autoFocus
            />
            <button
              type="submit"
              className="w-full bg-primary-green text-white py-3 rounded-lg font-bold hover:bg-primary-green-dark transition-colors"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Admin Panel Layout
  return (
    <div className="min-h-screen bg-neutral-gray">
      {/* Admin Header */}
      <div className="bg-primary-green-dark text-white py-4 px-6 shadow-md flex justify-between items-center sticky top-0 z-50">
        <div className="flex items-center gap-3">
          <span className="text-2xl">🛠️</span>
          <h1 className="text-xl font-display font-bold">
            The Tiny Times - Admin
          </h1>
        </div>
        <button
          onClick={() => {
            setIsAuthenticated(false);
            sessionStorage.removeItem('adminAuth');
          }}
          className="bg-white/10 hover:bg-red-500/80 px-4 py-2 rounded-lg transition-colors text-sm font-semibold"
        >
          Logout
        </button>
      </div>
      
      {/* Main Content */}
      <div className="container mx-auto p-4">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;